import Vue from "vue";
import VueRouter from "vue-router";
import beforeEach from "./beforeEach";
import Main from "../modules/main/Main.vue";
import Auth from "../modules/auth/Auth.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: { name: "Home" },
  },
  {
    path: "/",
    name: "Main",
    redirect: { name: "Home" },
    component: Main,
    children: [
      {
        path: "home",
        name: "Home",
        meta: { requiresAuth: true, title: "Início" },
        component: () => import("@/modules/main/views/home/Home.vue"),
      },
      {
        path: "profile",
        name: "Profile",
        redirect: { name: "General" },
        meta: { title: "Perfil", requiresAuth: true },
        component: () => import("@/modules/main/views/profile/Profile.vue"),
        children: [
          {
            path: "general",
            name: "General",
            meta: { title: "Geral", requiresAuth: true },
            component: () =>
              import(
                "@/modules/main/views/profile/children/general/General.vue"
              ),
          },
          {
            path: "informations",
            name: "Informations",
            meta: { title: "Minhas Informações", requiresAuth: true },
            component: () =>
              import(
                "@/modules/main/views/profile/children/informations/Informations.vue"
              ),
          },
          {
            path: "shipments",
            name: "Shipments",
            meta: { title: "Minhas Remessas", requiresAuth: true },
            component: () =>
              import(
                "@/modules/main/views/profile/children/shipments/Shipments.vue"
              ),
          },
          {
            path: "change-password",
            name: "ChangePassword",
            meta: { title: "Alterar senha", requiresAuth: true },
            component: () =>
              import(
                "@/modules/main/views/profile/children/changePassword/ChangePassword.vue"
              ),
          },
          {
            path: "change-email",
            name: "ChangeEmail",
            meta: { title: "Alterar e-mail", requiresAuth: true },
            component: () =>
              import(
                "@/modules/main/views/profile/children/changeEmail/ChangeEmail.vue"
              ),
          },
        ],
      },
      {
        path: "games",
        name: "Games",
        redirect: { name: "PrizeWord" },
        meta: { requiresAuth: true },
        component: () => import("@/modules/main/views/games/Games.vue"),
        children: [
          {
            path: "prize-word",
            name: "PrizeWord",
            meta: { requiresAuth: true, title: "Palavra Premiada" },
            component: () =>
              import(
                "@/modules/main/views/games/children/prizeWord/PrizeWord.vue"
              ),
          },
          {
            path: "lucky-path",
            name: "LuckyPath",
            meta: { requiresAuth: true, title: "Caminho da sorte" },
            component: () =>
              import(
                "@/modules/main/views/games/children/luckyPath/LuckyPath.vue"
              ),
          },
          {
            path: "hangman",
            name: "Hangman",
            meta: { requiresAuth: true, title: "Jogo da forca" },
            component: () =>
              import("@/modules/main/views/games/children/hangman/Hangman.vue"),
          },
          {
            path: "chico-challenge",
            name: "ChicoChallenge",
            meta: { requiresAuth: true, title: "Desafio do chico" },
            component: () =>
              import(
                "@/modules/main/views/games/children/chicoChallenge/ChicoChallenge.vue"
              ),
          },
        ],
      },
      {
        path: "raffles",
        name: "Raffles",
        meta: { requiresAuth: true, title: "Soteios" },
        component: () => import("@/modules/main/views/raffles/Raffles.vue"),
      },
      {
        path: "my-tickets",
        name: "MyTickets",
        meta: { requiresAuth: true, title: "Meus bilhetes" },
        component: () => import("@/modules/main/views/myTickets/MyTickets.vue"),
      },
      {
        path: "result/:id",
        name: "Result",
        meta: { requiresAuth: true, title: "Resultado do sorteio" },
        component: () => import("@/modules/main/views/result/Result.vue"),
      },
      {
        path: "winners",
        name: "Winners",
        meta: { requiresAuth: true, title: "Ganhadores" },
        component: () => import("@/modules/main/views/winners/Winners.vue"),
      },
      {
        path: "ranking",
        name: "Ranking",
        meta: { requiresAuth: true, title: "Ranking Apoiadores" },
        component: () => import("@/modules/main/views/ranking/Ranking.vue"),
      },
      {
        path: "wallet",
        name: "Wallet",
        meta: { requiresAuth: true, title: "Minha Carteira" },
        component: () => import("@/modules/main/views/wallet/Wallet.vue"),
      },
      {
        path: "affiliates",
        name: "Affiliates",
        meta: { requiresAuth: true, title: "Afiliados" },
        component: () =>
          import("@/modules/main/views/affiliates/Affiliates.vue"),
      },
      {
        path: "sponsor",
        name: "Sponsor",
        meta: { requiresAuth: true },
        component: () => import("@/modules/main/views/sponsor/Sponsor.vue"),
        children: [
          {
            path: "",
            name: "Campaigns",
            meta: { requiresAuth: true, title: "Patrocínio e propaganda" },
            component: () =>
              import(
                "@/modules/main/views/sponsor/children/campaigns/Campaigns.vue"
              ),
          },
          {
            path: "new-campaign",
            name: "NewCampaign",
            meta: { requiresAuth: true, title: "Nova campanha" },
            component: () =>
              import(
                "@/modules/main/views/sponsor/children/newCampaign/NewCampaign.vue"
              ),
          },
          {
            path: "campaign-details/:id",
            name: "CampaignDetails",
            meta: { requiresAuth: true, title: "Detalhes da campanha" },
            component: () =>
              import(
                "@/modules/main/views/sponsor/children/campaignDetails/CampaignDetails.vue"
              ),
          },
        ],
      },
      {
        path: "item-shop",
        name: "ItemShop",
        meta: { requiresAuth: true, title: "Loja de Itens" },
        component: () => import("@/modules/main/views/itemShop/ItemShop.vue"),
      },
      {
        path: "shipping/:productID",
        name: "Shipping",
        meta: { requiresAuth: true, title: "Envio" },
        component: () => import("@/modules/main/views/shipping/Shipping.vue"),
      },
      {
        path: "terms",
        name: "Terms",
        meta: { requiresAuth: true, title: "Termos" },
        component: () => import("@/modules/main/views/terms/Terms.vue"),
      },
      {
        path: "about",
        name: "About",
        meta: { requiresAuth: true, title: "Sobre" },
        component: () => import("@/modules/main/views/about/About.vue"),
      },
      {
        path: "help",
        name: "Help",
        meta: { requiresAuth: true, title: "Ajuda" },
        component: () => import("@/modules/main/views/help/Help.vue"),
      },
    ],
  },
  {
    path: "/auth",
    name: "Auth",
    redirect: { name: "SignIn" },
    component: Auth,
    children: [
      {
        path: "sign-in",
        name: "SignIn",
        meta: { title: "Entrar", preventAuth: true },
        component: () => import("@/modules/auth/views/signIn/SignIn.vue"),
      },
      {
        path: "sign-up",
        name: "SignUp",
        meta: { title: "Criar Conta", preventAuth: true },
        component: () => import("@/modules/auth/views/signUp/SignUp.vue"),
      },
      {
        path: "forgot-password",
        name: "ForgotPassword",
        meta: { title: "Esqueci minha senha", preventAuth: true },
        component: () =>
          import("@/modules/auth/views/forgotPassword/ForgotPassword.vue"),
      },
    ],
  },
  {
    path: "*",
    redirect: { name: "Home" },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(beforeEach);

export default router;
